import React from "react";

export const montserratTags = (
  <React.Fragment key="montserrat-font">
    <link
      rel="preload"
      as="font"
      href="https://s.catch.com.au/static/catch/fonts/Montserrat-Regular.woff2"
      type="font/woff2"
      crossOrigin="anonymous"
    />
    <link
      rel="preload"
      as="font"
      href="https://s.catch.com.au/static/catch/fonts/Montserrat-SemiBold.woff2"
      type="font/woff2"
      crossOrigin="anonymous"
    />
    <link
      rel="preload"
      as="font"
      href="https://s.catch.com.au/static/catch/fonts/Montserrat-Black.woff2"
      type="font/woff2"
      crossOrigin="anonymous"
    />
    <style
      dangerouslySetInnerHTML={{
        __html: `
          @font-face {
              font-family: "Montserrat";
              font-weight: 100;
              font-style: normal;
              font-display: swap;
              src: url("https://s.catch.com.au/static/catch/fonts/Montserrat-Thin.woff2") format("woff2"),
              url("https://s.catch.com.au/static/catch/fonts/Montserrat-Thin.woff") format("woff");
              unicode-range: U+000-5FF;
          }
          
          @font-face {
              font-family: "Montserrat";
              font-weight: 100;
              font-style: italic;
              font-display: swap;
              src: url("https://s.catch.com.au/static/catch/fonts/Montserrat-ThinItalic.woff2") format("woff2"),
              url("https://s.catch.com.au/static/catch/fonts/Montserrat-ThinItalic.woff") format("woff");
              unicode-range: U+000-5FF;
          }
          
          @font-face {
              font-family: "Montserrat";
              font-weight: 200;
              font-style: normal;
              font-display: swap;
              src: url("https://s.catch.com.au/static/catch/fonts/Montserrat-ExtraLight.woff2") format("woff2"),
              url("https://s.catch.com.au/static/catch/fonts/Montserrat-ExtraLight.woff") format("woff");
              unicode-range: U+000-5FF;
          }
          
          @font-face {
              font-family: "Montserrat";
              font-weight: 200;
              font-style: italic;
              font-display: swap;
              src: url("https://s.catch.com.au/static/catch/fonts/Montserrat-ExtraLightItalic.woff2") format("woff2"),
              url("https://s.catch.com.au/static/catch/fonts/Montserrat-ExtraLightItalic.woff") format("woff");
              unicode-range: U+000-5FF;
          }
          
          @font-face {
              font-family: "Montserrat";
              font-weight: 300;
              font-style: normal;
              font-display: swap;
              src: url("https://s.catch.com.au/static/catch/fonts/Montserrat-Light.woff2") format("woff2"),
              url("https://s.catch.com.au/static/catch/fonts/Montserrat-Light.woff") format("woff");
              unicode-range: U+000-5FF;
          }
          
          @font-face {
              font-family: "Montserrat";
              font-weight: 300;
              font-style: italic;
              font-display: swap;
              src: url("https://s.catch.com.au/static/catch/fonts/Montserrat-LightItalic.woff2") format("woff2"),
              url("https://s.catch.com.au/static/catch/fonts/Montserrat-LightItalic.woff") format("woff");
              unicode-range: U+000-5FF;
          }
          
          @font-face {
              font-family: "Montserrat";
              font-weight: 400;
              font-style: normal;
              font-display: swap;
              src: url("https://s.catch.com.au/static/catch/fonts/Montserrat-Regular.woff2") format("woff2"),
              url("https://s.catch.com.au/static/catch/fonts/Montserrat-Regular.woff") format("woff");
              unicode-range: U+000-5FF;
          }
          
          @font-face {
              font-family: "Montserrat";
              font-weight: 400;
              font-style: italic;
              font-display: swap;
              src: url("https://s.catch.com.au/static/catch/fonts/Montserrat-Italic.woff2") format("woff2"),
              url("https://s.catch.com.au/static/catch/fonts/Montserrat-Italic.woff") format("woff");
              unicode-range: U+000-5FF;
          }
          
          @font-face {
              font-family: "Montserrat";
              font-weight: 500;
              font-style: normal;
              font-display: swap;
              src: url("https://s.catch.com.au/static/catch/fonts/Montserrat-Medium.woff2") format("woff2"),
              url("https://s.catch.com.au/static/catch/fonts/Montserrat-Medium.woff") format("woff");
              unicode-range: U+000-5FF;
          }
          
          @font-face {
              font-family: "Montserrat";
              font-weight: 500;
              font-style: italic;
              font-display: swap;
              src: url("https://s.catch.com.au/static/catch/fonts/Montserrat-MediumItalic.woff2") format("woff2"),
              url("https://s.catch.com.au/static/catch/fonts/Montserrat-MediumItalic.woff") format("woff");
              unicode-range: U+000-5FF;
          }
          
          @font-face {
              font-family: "Montserrat";
              font-weight: 600;
              font-style: normal;
              font-display: swap;
              src: url("https://s.catch.com.au/static/catch/fonts/Montserrat-SemiBold.woff2") format("woff2"),
              url("https://s.catch.com.au/static/catch/fonts/Montserrat-SemiBold.woff") format("woff");
              unicode-range: U+000-5FF;
          }
          
          @font-face {
              font-family: "Montserrat";
              font-weight: 600;
              font-style: italic;
              font-display: swap;
              src: url("https://s.catch.com.au/static/catch/fonts/Montserrat-SemiBoldItalic.woff2") format("woff2"),
              url("https://s.catch.com.au/static/catch/fonts/Montserrat-SemiBoldItalic.woff") format("woff");
              unicode-range: U+000-5FF;
          }
          
          @font-face {
              font-family: "Montserrat";
              font-weight: 700;
              font-style: normal;
              font-display: swap;
              src: url("https://s.catch.com.au/static/catch/fonts/Montserrat-Bold.woff2") format("woff2"),
              url("https://s.catch.com.au/static/catch/fonts/Montserrat-Bold.woff") format("woff");
              unicode-range: U+000-5FF;
          }
          
          @font-face {
              font-family: "Montserrat";
              font-weight: 700;
              font-style: italic;
              font-display: swap;
              src: url("https://s.catch.com.au/static/catch/fonts/Montserrat-BoldItalic.woff2") format("woff2"),
              url("https://s.catch.com.au/static/catch/fonts/Montserrat-BoldItalic.woff") format("woff");
              unicode-range: U+000-5FF;
          }
          
          @font-face {
              font-family: "Montserrat";
              font-weight: 800;
              font-style: normal;
              font-display: swap;
              src: url("https://s.catch.com.au/static/catch/fonts/Montserrat-ExtraBold.woff2") format("woff2"),
              url("https://s.catch.com.au/static/catch/fonts/Montserrat-ExtraBold.woff") format("woff");
              unicode-range: U+000-5FF;
          }
          
          @font-face {
              font-family: "Montserrat";
              font-weight: 800;
              font-style: italic;
              font-display: swap;
              src: url("https://s.catch.com.au/static/catch/fonts/Montserrat-ExtraBoldItalic.woff2") format("woff2"),
              url("https://s.catch.com.au/static/catch/fonts/Montserrat-ExtraBoldItalic.woff") format("woff");
              unicode-range: U+000-5FF;
          }
          
          @font-face {
              font-family: "Montserrat";
              font-weight: 900;
              font-style: normal;
              font-display: swap;
              src: url("https://s.catch.com.au/static/catch/fonts/Montserrat-Black.woff2") format("woff2"),
              url("https://s.catch.com.au/static/catch/fonts/Montserrat-Black.woff") format("woff");
              unicode-range: U+000-5FF;
          }
          
          @font-face {
              font-family: "Montserrat";
              font-weight: 900;
              font-style: italic;
              font-display: swap;
              src: url("https://s.catch.com.au/static/catch/fonts/Montserrat-BlackItalic.woff2") format("woff2"),
              url("https://s.catch.com.au/static/catch/fonts/Montserrat-BlackItalic.woff") format("woff");
              unicode-range: U+000-5FF;
          }
        `,
      }}
    />
  </React.Fragment>
);
